export enum SemanaEnum {
  Lun = 'lun',
  Mar = 'mar',
  Mie = 'mié',
  Jue = 'jue',
  Vie = 'vie',
  Sab = 'sáb',
  Dom = 'dom',
}
